import React from 'react';
import { Grid } from "@material-ui/core";
import FlagIcon from '@material-ui/icons/Flag';
import pauta from 'data/pauta.json';

const CardPauta = () => {
    const hasPautaInfo = pauta && pauta.length > 0;

    return (
        <>
            <Grid container style={{ boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.5)', borderRadius: '1em', height: hasPautaInfo ? '100%' : '200px' }}>
                <Grid item style={{ width: '100%' }}>
                    <div style={{ backgroundColor: 'var(--azul)', color: 'var(--branco)', width: '100%', borderTopLeftRadius: '1em', borderTopRightRadius: '1em' }}>
                        <h1 style={{ margin: 0, padding: '0.6em', fontSize: '22px' }}>
                            <FlagIcon style={{ marginRight: '0.6em' }} />
                            Nossa Pauta
                        </h1>
                    </div>
{hasPautaInfo ? (
    pauta.map((item, index) => (
        <p style={{ margin: '1em', color: 'grey' }} key={index}>
            {item}
        </p>
    ))
) : (
    <>
        <p style={{ margin: '1em', color: 'grey' }}>
        </p>

        <ul style={{
            margin: '0 2em 1.5em 2em',
            color: 'grey',
            lineHeight: '1.6',
            listStyleType: 'disc'
        }}>
            <li>Projeto de Lei Complementar (PLP) 185/2024</li>
            <li>Projeto de Lei (PL) 1.559/2021</li>
            <li>PL 2.952/2025</li>
            <li> PL 4.012/2024</li>
        </ul>
    </>
)}

                </Grid>
            </Grid>
        </>
    );
}

export default CardPauta;
